import { Link } from 'react-router-dom';
import { cookiePolicySections } from '../data/cookiePolicy';
import { useCookieConsent } from '../context/CookieConsentContext';

export default function CookiePolicy() {
  const { openPreferences } = useCookieConsent();

  return (
    <div className="container legal-page">
      <nav className="legal-breadcrumb">
        <Link to="/">Ana Sayfa</Link>
        <span>/</span>
        <span>Çerez Politikası</span>
      </nav>

      <header className="legal-header">
        <h1>Çerez Politikası</h1>
        <p>
          Health Shop Longevity web sitesinde kullanılan çerezlere ilişkin bilgilendirme
          metnidir.
        </p>
        <button type="button" className="btn btn-outline" onClick={openPreferences}>
          Çerez Tercihleri
        </button>
      </header>

      <article className="legal-content">
        {cookiePolicySections.map((section) => (
          <section key={section.id} id={section.id} className="legal-section">
            {section.id !== 'intro' && <h2>{section.title}</h2>}

            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph.slice(0, 40)}>{paragraph}</p>
            ))}

            {section.list && (
              <ul>
                {section.list.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}

            {section.subsections?.map((subsection) => (
              <div key={subsection.title} className="legal-subsection">
                <h3>{subsection.title}</h3>
                {subsection.paragraphs.map((paragraph) => (
                  <p key={paragraph.slice(0, 40)}>{paragraph}</p>
                ))}
                {subsection.list && (
                  <ul>
                    {subsection.list.map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}

            {section.contact && (
              <dl className="legal-contact">
                {section.contact.map((item) => (
                  <div key={item.label} className="legal-contact-row">
                    <dt>{item.label}</dt>
                    <dd>
                      {item.href ? (
                        <a href={item.href}>{item.value}</a>
                      ) : (
                        item.value
                      )}
                    </dd>
                  </div>
                ))}
              </dl>
            )}
          </section>
        ))}
      </article>
    </div>
  );
}
